import { useCallback, useState } from "react";
import {
  selectIsLocalAudioEnabled,
  selectLocalPeer,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import { useLiveSettingsActions } from "../../store";

export const useHMSMicrophone = () => {
  const [isMicrophonePending, setIsMicrophonePending] = useState(false);
  const hmsActions = useHMSActions();
  const isMicrophoneEnabled = useHMSStore(selectIsLocalAudioEnabled);
  const { setMicrophoneEnabled } = useLiveSettingsActions();
  const localPeer = useHMSStore(selectLocalPeer);
  const isLocalAudioReady = !!localPeer?.audioTrack;

  const toggleMicrophone = useCallback(async () => {
    try {
      if (isLocalAudioReady) {
        setIsMicrophonePending(true);
        await hmsActions.setLocalAudioEnabled(!isMicrophoneEnabled);
        setMicrophoneEnabled(!isMicrophoneEnabled);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "";
      console.error("Could not toggle microphone: ", errorMessage);
    } finally {
      setIsMicrophonePending(false);
    }
  }, [
    isMicrophoneEnabled,
    isLocalAudioReady,
    hmsActions,
    setMicrophoneEnabled,
  ]);

  return {
    isMicrophoneEnabled,
    isMicrophonePending: !isLocalAudioReady || isMicrophonePending,
    toggleMicrophone,
  };
};
